import {Map, List, fromJS} from 'immutable';

export const getHasBillingInfo = (state) => state.getIn(['company', 'billing', 'hasInfo'], false);
export const getCompanyBillingInfo = (state) => state.getIn(['company', 'billing', 'info'], Map());
export const getPaymentPlan = (state) => state.getIn(['company', 'info', 'payment_status', 'plan', 'package'])
export const getPaymentStatus = (state) => state.getIn(['company', 'info', 'payment_status', 'status'])
export const getWillCancelSub = (state) => state.getIn(['company', 'info', 'payment_status', 'will_cancel_subscription'])
export const getPaymentPeriod = (state) => state.getIn(['company', 'info', 'payment_status', 'period'])
export const getCurrentSub = (state) => state.getIn(['company', 'info', 'payment_status', 'plan', 'subscription'])

export const getCompanyInfo = (state) => state.getIn(['company', 'info'], Map());
export const getCompanyName = (state) => state.getIn(['company', 'info', 'name'], '')
export const getCompanyDisplayName = (state) => state.getIn(['customization', 'payload', 'company_display_name'])
export const getHistory= (state) => {
    return state.getIn(['company', 'history'], Map());
    }
export const getCurrentPage = (state) => state.getIn(['company', 'history', 'currentPage'], 0);
export const getCurrentPageTickets = (state) => {
    let currentPage = getCurrentPage(state)
    let ticketsRoom = state.getIn(['company', 'history', 'pages', currentPage],List()).toJS()
    let tickets = []
    ticketsRoom.map((room) => {
        let ticket = state.getIn(['conversation', 'items', room, 'info', 'payload'])
        if(ticket) tickets.push(ticket)
        return false
    })
    return fromJS(tickets)
}
const getCompanyRoom = (state) => state.getIn(['company', 'info', 'employees_room'])

export const invoices = (state) => state.getIn(['company', 'invoice', 'info'])
export const invoicesIsFetching = (state) => state.getIn(['company', 'invoice', 'isFetching'])
export const isClientChatAvailable = (state) => state.getIn(['company', 'info', 'is_available'])

export default {
  getHasBillingInfo, getHistory, getCompanyInfo, getCurrentPage, getCurrentPageTickets,
  invoices, invoicesIsFetching, getCompanyBillingInfo, isClientChatAvailable,
  getCompanyRoom, getCompanyName, getPaymentPlan, getCompanyDisplayName,getPaymentStatus,
  getWillCancelSub, getPaymentPeriod, getCurrentSub
}



// WEBPACK FOOTER //
// ./src/model/Company/selector.js